type Props = {
  label: string;
};

const AuthFormTitle = ({ label }: Props) => {
  return <h1 className="text-2xl font-medium mb-1">{label}</h1>;
};

export default AuthFormTitle;
